import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import useSEO from "../lib/useSEO";

export default function NotFoundPage() {
  useSEO({
    title: "404 — Halaman Tidak Ditemukan | Ace Sublimasi Nusantara",
    description:
      "Halaman yang kamu cari tidak ditemukan. Kembali ke beranda Ace Sublimasi Nusantara.",
  });

  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <p className="font-display text-[120px] md:text-[200px] leading-none text-[#CCFF00]">
          404
        </p>
        <h1 className="font-display text-3xl sm:text-5xl uppercase text-white">
          Halaman Tidak Ditemukan
        </h1>
        <p className="mt-4 text-base text-[#A3A3A3]">
          Mungkin link-nya udah pindah atau memang belum ada. Kembali ke beranda dulu yuk.
        </p>
        <Link to="/" data-testid="not-found-home" className="btn-primary mt-8 inline-flex">
          <ArrowLeft className="w-4 h-4" /> Ke Beranda
        </Link>
      </div>
    </div>
  );
}
